import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { BreadcrumbService } from '../breadcrumb.service';
import { IUser } from '../shared/Domains/IUser';
import { IPettyExpense } from '../shared/Domains/IPettyExpense'
import { IRole } from '../shared/Domains/role';
import { Router } from '@angular/router';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from 'app/shared/Domains/branch';
@Component({
  selector: 'app-pettycashdialouge',
  templateUrl: 'pettycashdialouge.component.html',
  styleUrls: ['pettyCashdialouge.component.css']
})
export class PettyCashDialougeComponent implements OnInit {
  @Input() pettydialogVisibility: any;
  @Output() closePettyCashDialog = new EventEmitter<any>();
  currentDate: string = new Date().toISOString().split('T')[0];
  user: IUser;
  loading: boolean;
  role: IRole;
  amount: number;
  selectedUser: string;
  purchasedItem: string;
  billType: string;
  description: string;
  paymentMode: string;
  expenseType: string;
  expenseDate: Date;
  paymentOptions = [];
  pettyExpenseDialogVisibility: boolean;
  pettyExpenses: IPettyExpense[];
  Users: any[];
  userOptions: any[];
  branch: IBranch;
  expenseTypeOptions: any[];
  usersOptions: any[];
  today: string;
  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    public config: Configuration,
    private router: Router,
    private appServiceManager: AppServiceManager,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Petty Cash' }
    ]);

  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PettyCashComponent", label);
  }
  ngOnInit() {
    this.user = AuthService.getLoggedInUser();
    this.amount = 0;
    this.expenseType = "";
    this.purchasedItem = "";
    this.billType = "";
    this.description = "";
    this.userOptions = [{ label: "Select User", value: null }];
    this.expenseTypeOptions = [
      { label: "Select", value: null },
      { label: "Rent", value: this.setLabel("rentLabel") },
      { label: "Salary", value: this.setLabel("salaryLabel") },
      { label: "Purchasing", value: this.setLabel("purchasingLabel") },
      { label: "Lending", value: this.setLabel("lendingLabel") },
      { label: "Bills", value: this.setLabel("billsLabel") },
      { label: "Account Deducted", value: this.setLabel("accountDeductedLabel") },
    ];
    this.usersOptions = [{ label: "Select Name", value: null }];
    this.paymentOptions = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
    ];
    this.paymentMode = "Cash-Reception";
    this.today = new Date().toISOString().split('T')[0];
    this.getUserByID();
    this.getBranch();
    this.getUserPettyExpenses();
    this.role = AuthService.getLoggedInRole();
    this.getAllUsers();

  }

  getUserByID() {
    this.appServiceManager.get("users/" + this.user._id).subscribe(res => {
      if (res) {
        this.user = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(this.branch){
      if (Array.isArray(this.branch.payments)) {
        this.branch.payments.forEach(payment => {
          const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
          if (!existingBank) {
            this.paymentOptions.push({
              label: `${payment.type} - ${payment.name}`,
              value: `${payment.type}-${payment.name}`
            });
          }
        });
      }
    }
    if(!this.branch){
      this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
        if (res) {
          res.payments.forEach(payment => {
            const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
            if (!existingBank) {
              this.paymentOptions.push({
                label: `${payment.type} - ${payment.name}`,
                value: `${payment.type}-${payment.name}`
              });
            }
          });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
      }
  }

  getUserPettyExpenses() {
    this.appServiceManager.get("pettyExpense/" + this.user._id).subscribe(res => {
      if (res) {
        this.pettyExpenses = res.response;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  showAddExpensePopup() {
    this.pettyExpenseDialogVisibility = true;
    this.amount = 0;
    this.expenseType = "";
    this.purchasedItem = "";
    this.billType = "";
    this.description = "";
  }

  onPaymentModeChange(value: string) {
    this.paymentMode = value;
  }

  dropdownChange(e) {
    console.log(e);
    this.selectedUser = e.value;
  }

  expenseTypeDropdownChange(e) {
    console.log(e);
    this.expenseType = e.value;
  }

  addPettyExpense() {
    if (this.amount > this.user.pettyCash) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Not enough amount in balance.' });
      return;
    }
    if (this.amount <= 0 || this.expenseType.length <= 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Add proper amount or expanse type.' });
      return;
    }
    if (!this.expenseDate) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Expense Date Not Select.' });
      return;
    }
    const expense = {
      amount: this.amount,
      type: this.expenseType,
      date: this.expenseDate,
      borrowerName: undefined,
      accountHolderName: undefined,
      accountHolderId: undefined,
      isDeducted: false,
      borrowerId: undefined,
      purchasedItem: this.purchasedItem,
      billType: this.billType,
      description: this.description,
      user: this.user._id,
      branch: this.user.branch,
      company: this.user.company,
      createdBy: this.user._id,
      modeOfPayment: this.paymentMode,
      scope: 'Petty Cash',
      initiatedFrom: 'Petty Cash Dialogue',
      activityBy: this.user.name,
      subject: this.expenseType,
      employee: this.selectedUser
    }

    if (this.expenseType === "Lending") {
      expense.borrowerName = this.Users.filter(u => u._id === this.selectedUser)[0].name;
      expense.borrowerId = this.selectedUser;
    }
    if (this.expenseType === "Account Deducted") {
      expense.accountHolderName = this.Users.filter(u => u._id === this.selectedUser)[0].name;
      expense.accountHolderId = this.selectedUser;
    }
    if (this.expenseType === "Salary") {
      expense.employee = this.Users.filter(u => u._id === this.selectedUser)[0].name;
    }

    this.appServiceManager.post("pettyExpense", expense).subscribe(res => {
      if (res) {
        this.onBeforeDialogHide()
        this.pettyExpenseDialogVisibility = false;
        this.getUserByID();
        this.getUserPettyExpenses();
        this.amount = 0;
        this.expenseType = "";
        this.purchasedItem = "";
        this.billType = "";
        this.description = "";
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Expenses added Successfully' });
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getAllUsers() {
    this.Users = [];
    this.loading = true;
    this.appServiceManager.get('users/company/' + this.user.company + '/branch/' + this.user.branch).subscribe(
      (res) => {
        if (res.length > 0) {
          this.Users = res;
          this.setUserData(this.Users);
          console.log("All Users", this.Users);

        } else {
          this.Users = [];
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "No Record Found",
          });
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }

  setUserData(Users) {

    this.Users.forEach((Users) => {
      this.userOptions.push({
        label: Users.name,
        value: Users._id,
      });
      this.usersOptions.push({
        label: Users.name,
        value: Users._id,
      });
    });
  }
  onBeforeDialogHide() {
    this.closePettyCashDialog.emit();
  }



}
